import { CreditCard } from "@/data/schemas";
import { CREDIT_CARDS } from "@card-data/data";

export const getCreditCards = (): CreditCard[] => CREDIT_CARDS;

export const useCreditCards = (): CreditCard[] => CREDIT_CARDS;
